import { SortingRule } from 'react-table';

export type DropDownItem = { val: string; label: string };

export type FiscalYearPair = {
  from: number;
  to: number;
};

export enum Status {
  Pending = 'pending',
  Done = 'done',
  Filed = 'filed',
  Overdue = 'overdue',
}

export enum GstTypes {
  GSTR1 = 'GSTR1',
  GSTR2B = 'GSTR2B',
  GSTR3B = 'GSTR3B',
  PT = 'PT',
  PF = 'PF',
  ESI = 'ESI',
}

export type Pagination = {
  pageable: {
    sort: {
      empty: boolean;
      unsorted: boolean;
      sorted: boolean;
    };
    offset: number;
    pageNumber: number;
    pageSize: number;
    unpaged: boolean;
    paged: boolean;
  };
  totalPages: number;
  totalElements: number;
  last: boolean;
  sort: {
    empty: boolean;
    unsorted: boolean;
    sorted: boolean;
  };
  size: number;
  number: number;
  numberOfElements: number;
  first: boolean;
  empty: boolean;
};

export type PaginatedResponse<T = any[]> = {
  content: T;
} & Pagination;

export type NewPaginatedResponse<T = any[]> = {
  data: T;
} & Pagination;

export type PaginatedRequest = {
  page: number;
  size?: number;
  sortBy: SortingRule<object>[];
  query: string;
};

export type PmPaginatedRequest = {
  page_num: number;
  page_size?: number;
  sort_by: SortingRule<object>[];
  query: string;
  filter?: string;
  custom_params?: Record<string, string | undefined>;
};

export type SelectOption<T = string, O = any> = {
  value: T;
  label: string;
  prefixEl?: any;
  original?: O;
};

export type GroupedSelectOption<T = string, O = any> = {
  label: string;
  options: SelectOption<T, O>[];
};

export type HttpResponse<T> = {
  _payload: T;
  _status: HttpResponseStatus;
  _code: number;
  _message: string;
};

export type PmHttpResponse<T = unknown> = {
  data: T;
  error?: {
    message: string;
    status_code: number;
    reason: string;
    errors: string[];
  };
  count?: number;
  page?: number;
  page_limit?: number;
  total?: number;
};

export type PmHttpResponse2<T> = {
  error: boolean;
  page: number;
  page_limit: number;
  total: number;
  data: T;
};

export enum CustomerType {
  Customer = 'customer',
  Investor = 'investor',
  Internal = 'internal',
}

export enum DocType {
  Pdf = 'pdf',
  Image = 'image',
  None = 'none',
}

export enum ReportGroupByRequestFilter {
  Day = 'day',
  Week = 'week',
  Month = 'month',
}

export enum BusinessType {
  Startup = 'Startup',
  ECommerce = 'E-commerce',
  Other = 'Other',
}

export enum SelectDropdownEvents {
  Create = 'Create',
  Select = 'Select',
  Delete = 'Delete',
}

export enum HttpResponseStatus {
  OK = 'ok',
  WARN = 'warn',
  ERROR = 'error',
}

export type SvgIcon =
  | ((props: React.SVGProps<SVGSVGElement>) => JSX.Element)
  | React.FunctionComponent<React.PropsWithChildren<React.SVGProps<SVGSVGElement> & {
    title?: string | undefined;
  }>>;

export type SvgLogo = SvgIcon;

export type CommonValueResponse = {
  value: string;
};
